import type { EventPlanInputChange } from '@/gen/cortado/v1/event_plan_pb'

/**
 * One input change, worded for a stale notice: "Guests changed from 75 to
 * 90". A side with no value reads "none" ("Guests changed from none to 90").
 * Changes with no single value to show (add-on set, settings, calculation
 * version) keep their label ("Add-ons changed"). Shared by the packing list
 * and timeline cards so both word the same change the same way.
 */
export function describeInputChange(change: EventPlanInputChange): string {
  if (change.fromValue || change.toValue) {
    return `${change.label} changed from ${change.fromValue || 'none'} to ${change.toValue || 'none'}`
  }
  return change.label
}
